import React from 'react';
import {Translation} from 'react-i18next';
import {Form, Select} from 'antd';


const RecurringInput = ({name, label, onChange=null, fieldKey=null, rules=null, disabled=false, ...props}) => {

  const options = [
    {
      value: 1,
      label: "calendar_recurring_none",
    },
    {
      value: 2,
      label: "calendar_event_recurring_type_2",
    },
    {
      value: 3,
      label: "calendar_event_recurring_type_3",
    },
    {
      value: 4,
      label: "calendar_event_recurring_type_4",
    },
    {
      value: 5,
      label: "calendar_event_recurring_type_5",
    },
  ];

  return (
    <Translation>{(t) => 
      <div className="form-group">
        <Form.Item
          name={name}
          fieldKey={fieldKey}
          label={label || ''}
          rules={rules}
        >
          <Select disabled={disabled} onChange={onChange}>
            {options.map(x => <Select.Option key={x.value} value={x.value}>{t(x.label)}</Select.Option>)}
          </Select>
        </Form.Item>
      </div>
    }</Translation>
  );
}

export default RecurringInput;
